/** @jsx jsx */

import {
  Fragment as _,
  useState,
  useContext,
  useRef,
  useMemo,
  useEffect,
  useLayoutEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext } from './interactionContext';
import { InteractionContext as ContainerContext } from '../../Layouts/ContainerLogical';
import { unlockInteraction } from 'services/unlockInteraction';
import isIE from 'services/isIE';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import getStore from 'services/getStore';
import EditWrapper from './EditWrapper';
import { useSelector } from 'react-redux';
import HotspotSVGError from 'assets/HotspotSVGError.svg';
import hexToRGB from 'services/hexToRGB';
import getBlockById from 'services/apiHelpers/getBlockById';
import Feedback from './Feedback';
import VisibleHotSpot from './VisibleHotSpot';
import { Polygon } from './Polygon';
import Rectangle from './Rectangle';
import LoadingSpinner from 'components/UI/LoadingSpinner';
import pubSub from 'services/pubSub';
import setNewBlockNewTree from 'services/apiHelpers/setNewBlockNewTree';
import { getNextHotSpotBlock } from 'factories/interactions/hotspot_isolated';
import { setBlocksAction } from 'actions/setBlocksAction';
import { getSVGSize } from 'services/getSVGSize';
import { useHotSpotTransformOldToNew } from './useHotSpotTransformOldToNew';
import { colors } from 'styles/variables';
import {
  HotSpotScorableContext as _HotSpotScorableContext,
  IHotSpotScorableContext,
} from './HotSpotScorable';
import { getMouseEvents } from './getMouseEvents';
//
import hotspotDefaultIMG_ from 'assets/Long Rectangle.svg';
// Widest Image.png';
// import hotSpotBaseImgPlaceholder from 'assets/Long Rectangle.svg';
import hotSpotLandingPageDefaultIMG_ from 'assets/hotspotLandingPageImg.png';
import hotspotQuizImg_ from 'assets/hotspotQuizImg.png';
import { lastCharInStringIsPeriod } from 'services/lastCharInStringIsPeriod';
import { ModuleContext } from 'components/Module/Module_v2';
import { State } from 'store/store';
import setBlockProps from 'services/apiHelpers/setBlockProps';

import { HostingContext } from 'hosting/context';
import { hotspotEvent, hotspotQuizEvent } from 'hosting/events';

// circleci: 0

export const OPEN_GLOBAL_NAVIGATION_ = 'OPEN_GLOBAL_NAVIGATION_';

const store = getStore();
const { lPink } = colors;

const HotSpot = ({ children, ...props }) => {
  const context: any = useContext(interactionContext);
  const hostingCtx = useContext(HostingContext);

  const containerContext = useContext(ContainerContext);

  let {
    id,
    image,
    src,
    // imgWidth = 2000 || 960,
    // imgHeight = 685 || 465,
    hotspotType = 'circle',
    hotSpotColor = '#D1D5E7',
    hotSpotSize,
    hotSpots,
    hotSpotsAnimated = true,
    hotSpotsVisible = true,
    useMediaInFeedback = true,
    showSeenState = true,
    rectangleBorderRadius = 0,
    rectangleDisplayOutlineOnly = false,
    description = '',
  } = props;

  const moduleContext = useContext(ModuleContext);
  const { exit, setComplete, setCompleteAndExit, resetModule } = moduleContext;

  const {
    immediateFeedback = true,
    score = false,
    isGlobalNavigation = false,
    sId,
    fullWidth,
  } = context?.props;

  const imgWidth = fullWidth ? 2084 : 960;
  const imgHeight = fullWidth ? 709 : 465;

  if (!image) {
    image = hotspotDefaultIMG_;

    // if (!immediateFeedback) {
    //   image = hotspotQuizImg_;
    // }

    // if (isGlobalNavigation) {
    //   image = hotSpotLandingPageDefaultIMG_;
    // }
  }

  if (src) {
    image = src;
  }

  const HotSpotScorableContext: any = useContext(_HotSpotScorableContext);

  const {
    updateAttempt,
    correctAnswers = [],
    selected = [],
    updateSelected,
    submitState,
    showCorrectAnswer,
  } = HotSpotScorableContext;

  const isFocused = getStore().getState().focusedNodeId === id;
  const [imgSize, setImgSize] = useState([imgWidth, imgHeight]);
  const [imgLoading, setImgLoading] = useState(0);
  const [creating, setCreating] = useState(false);
  const [hotSpotFocus, setHotSpotFocus] = useState<string | undefined>(
    undefined
  );

  const [SVGHasNoDimensionsError, setSVGHasNoDimensionsError] = useState<
    boolean
  >(false);

  const [showFeedback, setShowFeedback] = useState<string | null>(null);

  const [{ scale, inverseScale }, setScale] = useState({
    scale: 1 || 0.3,
    inverseScale: 1 || 1 * (1 / 0.3),
  });

  const [currentHotspotId, setCurrentHotspotId] = useState<string | undefined>(
    undefined
  );

  const landingPageSeenState = useSelector((state: State) => {
    return state?.landingPagesSeenState?.[sId || context.id] || [];
  });

  const updateHotspotSeen = (id: number, clear?: boolean) => {
    if (!immediateFeedback) {
      return;
    }

    store.dispatch({
      type: 'UPDATE_LANDING_PAGE_SEEN_STATE',
      data: {
        parentId: sId || context.id,
        childIndex: children.findIndex(child => {
          return child?.props?.id === id;
        }),
        clear,
      },
    });
  };

  const container = useRef<HTMLDivElement>(null);
  const root = useRef<HTMLDivElement>(null);
  const mounted = useRef(true);
  const currentHotspot = useRef<string | null>(null);
  const hasPointsOnProps = useRef<boolean | undefined>(undefined);

  const drawing = useRef<boolean>(false);
  const startXY = useRef<{ startX: number; startY: number }>({
    startX: 0,
    startY: 0,
  });
  const rectState = useRef<any>({});

  let { isOpen } = context;

  const interactionsLocked = useSelector(
    (state: any) => state.interactionsLocked
  );

  const interactionsOpen: any = useSelector(
    (state: any) => state.interactionsOpen
  );

  if (interactionsOpen.includes(context.id)) {
    isOpen = true;
  }

  const { r, g, b } = hexToRGB(hotSpotColor);

  const getParsedColor = opacity => {
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  //

  const names: string[] = [];
  const points: (number[] | number)[] = children.map((child, index) => {
    const { name, points, updated } = child?.props;

    names.push(name);

    // if there's no hotpsots it's because they were removed explicitly by code
    // in the last update cycle
    // WE DO NOT WANT TO DO THAT GOING FORWARD !!!
    // we set an updated prop to some value explicitly when that point has been
    // updated in the editor. we can preference it then for use
    // otherwise. we use what's on the hotSpots

    //

    // can't use hotSpots[name] since there's potentially dupes
    return !hotSpots || updated ? points : Object.values(hotSpots)[index];
  });

  const hotSpotFocusRef = useRef<string | undefined>(undefined);
  const rectangleCoords = useRef<any>({});

  useHotSpotTransformOldToNew({
    id,
    hotSpots,
    children,
    getNextHotSpotBlock,
    getBlockById,
    setNewBlockNewTree,
    store,
    setBlocksAction,
  });

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    // if already unlocked. bail
    if (!interactionsLocked.includes(context.id)) {
      return;
    }

    if (landingPageSeenState.length === children.length) {
      unlockInteraction(context.id);
    }
  }, [landingPageSeenState.length]);

  useEffect(() => {
    const pS = pubSub.subscribe(`CURRENT_HOTSPOT_ID_${id}`, $ => {
      const { hotspotsBlockId, currentHotspotId } = $;

      setCurrentHotspotId(currentHotspotId);
    });

    return () => {
      pS();
    };
  });

  useEffect(() => {
    const pS = pubSub.subscribe(`ON_HOTSPOT_HOVER`, ({ hotspotId, hover }) => {
      const hotSpotRoot = document.querySelector(`#hotspots-${id}`);

      if (!hotSpotRoot) return;

      const markers = Array.from(
        hotSpotRoot.querySelectorAll(
          hotspotType === 'rectangle' ? 'rect' : hotspotType
        )
      );

      if (!markers.length) {
        return;
      }

      markers.forEach(
        (marker: any) => (marker.style.fill = getParsedColor(0.5))
      );

      if (!hover) return;

      const marker: any = markers.find(
        (marker: any) => marker.id === `hotspot-${hotspotId}`
      );

      if (marker) {
        marker.style.fill = getParsedColor(0.8); // 'rgba(255, 0, 99, 0.8)'
      }
    });

    return () => {
      pS();
    };
  }, [hotspotType, hotSpotColor]);

  useLayoutEffect(() => {
    const onResize = () => {
      if (container.current) {
        const { width, height } = container.current.getBoundingClientRect();
        if (imgSize[0]) {
          let $ = width / imgSize[0];

          if (imgSize[0] <= width) {
            $ = 1;
          }

          if (mounted.current) {
            setScale({
              scale: $,
              inverseScale: 1 * (1 / $),
            });
            //
            requestAnimationFrame(() => {
              pubSub.publish('UPDATE_HOTSPOT_SCALE_FACTORS', {
                scale: $,
                inverseScale: 1 * (1 / $),
              });
            });
          }
        }
      }
    };

    onResize();
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [isOpen, imgSize]);

  useEffect(() => {
    setImgLoading(1);
    setSVGHasNoDimensionsError(false);

    //

    let svgImgWidth = imgWidth;
    let svgImgHeight = imgHeight;

    if (/\.(svg)$/i.test(image)) {
      getSVGSize(image)
        .then((size: any) => {
          svgImgWidth = size.width;
          svgImgHeight = size.height;
        })
        .catch(err => {
          if (window.dev()) {
            alert(
              `This svg image does not have a value for width and/or height. It will default to ${svgImgWidth}*${svgImgHeight}`
            );
          }
        })
        .finally(() => {
          setImgLoading(2);
          setImgSize([svgImgWidth, svgImgHeight]);
        });
    } else {
      const img = new Image();
      img.src = image;

      if (window.dev()) {
        img.onerror = e => {
          // if an error occurs loading the current src
          // let's clear it out and prompt a retry;

          setBlockProps(getBlockById(id), {
            src: '',
          });

          alert(
            'There was an error while attempting to load your image. Please try again.'
          );
        };
      }

      img.onload = e => {
        setImgLoading(2);
        setImgSize([img.width, img.height]);
      };
    }
  }, [isOpen, image, fullWidth]);

  let feedback = children.filter(child => {
    const { id, name } = child?.props as any;
    return [id, name].includes(showFeedback);
  });

  feedback = feedback[0]?.props.children;

  const showChecked = (index, id) => {
    if (immediateFeedback || submitState !== 'resolved' || !showCorrectAnswer) {
      return (
        showSeenState &&
        (landingPageSeenState.includes(index) || selected.includes(index))
      );
    }

    if (showCorrectAnswer !== undefined) {
      return submitState === 'resolved'
        ? correctAnswers.includes(index)
        : undefined;
    }
  };

  const { onMouseDown, onMouseMove, onMouseUp, onClick } = useMemo(() => {
    return getMouseEvents({
      hotspotType,
      drawing,
      startXY,
      root,
      inverseScale,
      rectState,
      pubSub,
    });
  }, [hotspotType, inverseScale]);

  // gotta fix my deps

  const getShapeProps = ({ id, index }) => {
    let hasBeenSeen;

    if (!immediateFeedback) {
      hasBeenSeen = selected.includes(index);
    } else {
      hasBeenSeen = landingPageSeenState.includes(index);
    }
    //

    return {
      id: `hotspot-${id}`,
      color: getParsedColor(0.8),
      hotSpotsAnimated: submitState === 'resolved' ? false : hotSpotsAnimated,
      hotSpotsVisible,
      size: hotSpotSize * inverseScale,
      inverseScale,
      creating,
      hasBeenSeen,
      showSeenState,
      showCorrectAnswer:
        submitState === 'resolved' && showCorrectAnswer
          ? correctAnswers.includes(index)
          : undefined,
      submitState,
      showChecked: showChecked(index, id),
      hotSpotFocus,
      immediateFeedback,

      isCorrect: correctAnswers.includes(index),
      selected: selected.includes(index),
      correctAnswers,
      enabled: !immediateFeedback && !selected.includes(id),
      onClick(e) {
        if (isGlobalNavigation) {
          if (window.dev()) {
            pubSub.publish(`OPEN_GLOBAL_NAVIGATION_${context.id}`, {
              id,
            });

            return;
          }

          const { linkData } = children[index]?.props;

          if (linkData?.url) {
            const { url, target } = linkData;

            requestAnimationFrame(() => {
              updateHotspotSeen(id);
            });

            switch (url) {
              case 'next': {
                containerContext.next(url);
                return;
              }
              case 'exit': {
                exit();
                return;
              }
              case 'setComplete': {
                setComplete();
                return;
              }
              case 'setCompleteAndExit': {
                setCompleteAndExit();
                return;
              }
              case 'resetModule': {
                resetModule();
                return;
              }
            }

            //

            if (target === '_self') {
              window.location.hash = url;

              hostingCtx?.data(
                hotspotEvent(context.id, {
                  hotspot_id: id,
                })
              );

              return;
            }

            window.open(url, target);
          }

          return;
        }

        if (!immediateFeedback) {
          // we're quizzin' it
          if (window.dev()) {
            return;
          } else {
            updateSelected(index);

            return;
          }
        }

        setShowFeedback(hotSpots ? names[index] : id);

        //
        hostingCtx?.data(
          hotspotEvent(context.id, {
            hotspot_id: id,
          })
        );

        requestAnimationFrame(() => {
          updateHotspotSeen(id);
        });
      },
    };
  };

  return !!imgSize.length ? (
    <div
      ref={container}
      css={css`
        position: relative;
        display: flex;
        justify-content: center;
        min-height: ${imgSize[1] * scale}px;

        ${isIE() &&
          `
          width: 100%;
          overflow: hidden;
        `}

        ${submitState === 'resolved' &&
          `
          * {
            pointer-events: none !important;
          }
    `}
      `}
    >
      <div className="sr-only">
        <p>{description}</p>
      </div>
      <div
        css={css`
          position: relative;
          width: ${imgSize[0] * scale}px;
          height: ${imgSize[1] * scale}px;
          * {
            margin: 0;
            padding: 0;
          }
        `}
      >
        <div
          ref={root}
          id={`hotspots-${id}`}
          css={css`
            position: absolute;
            left: 0;
            top: 0;
            width: ${imgSize[0]}px;
            height: ${imgSize[1]}px;
            transform: scale(${scale});
            transform-origin: 0 0;
          `}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onClick={onClick}
        >
          {[0, 2].includes(imgLoading) ? (
            <svg
              viewBox={`0 0 ${imgSize[0]} ${imgSize[1]}`}
              preserveAspectRatio="xMidYMid meet"
              overflow="visible"
              onClick={e => {
                if (e.target !== e.currentTarget) {
                  return;
                }
              }}
            >
              <image
                xlinkHref={image}
                width={imgSize[0]}
                height={imgSize[1]}
                style={{
                  pointerEvents: 'none',
                }}
              />
              {/* <title>{description}</title> */}
              {(!window.dev() ? true : isFocused) &&
                points
                  .filter((points: any) => {
                    if (SVGHasNoDimensionsError) {
                      return false;
                    }

                    if (['rectangle', 'polygon'].includes(hotspotType)) {
                      return true;
                    }

                    if (points?.length && points?.every(entry => entry > 0)) {
                      return true;
                    }
                  })
                  .map((points: any, i) => {
                    const id = children[i]?.props.id;

                    if (hotspotType === 'rectangle') {
                      return (
                        <Rectangle
                          key={`hotspot-${i}-${JSON.stringify(points)}`}
                          {...{
                            ...getShapeProps({ id, index: i }),
                            points: points || [],

                            color: hotSpotColor,
                            rectangleBorderRadius,
                            rectangleDisplayOutlineOnly,
                            currentHotspotId,
                          }}
                        />
                      );
                    }

                    if (hotspotType === 'polygon') {
                      return (
                        <Polygon
                          key={`hotspot-${i}-${hotSpotColor}`}
                          {...{
                            ...getShapeProps({ id, index: i }),
                            points: (Array.isArray(points) ? points : []).join(
                              ' '
                            ),
                            hotSpotColor,
                            r,
                            g,
                            b,
                          }}
                        />
                      );
                    }

                    if (hotspotType === 'circle') {
                      return (
                        <VisibleHotSpot
                          key={`hotspot-${i}`}
                          {...{
                            ...getShapeProps({ id, index: i }),
                            location: [points[0], points[1]],
                          }}
                        />
                      );
                    }
                  })}
            </svg>
          ) : (
            <LoadingSpinner
              size={46 * inverseScale}
              lineWeight={5 * inverseScale}
            />
          )}
        </div>

        <div
          css={css({
            position: 'absolute',
          })}
        >
          {children.map((child, index) => {
            const { id, name, linkData } = child.props;

            const keyId = `hotspot-focus-trigger-${id}`;

            // some title/label additional thing to have parity with showing ticks
            const titleOrLabel =
              (isGlobalNavigation ? linkData?.title || linkData?.url : name) ||
              '';

            const addHasBeenSeenTitleOrLabel = landingPageSeenState.includes(
              index
            )
              ? `${!lastCharInStringIsPeriod(titleOrLabel) ? '.' : ''} Seen.`
              : '';

            return isGlobalNavigation ? (
              <a
                key={keyId}
                id={keyId}
                href={window.dev() ? null : linkData?.url}
                title={`${linkData?.title ||
                  linkData?.url}${addHasBeenSeenTitleOrLabel}`}
                target={linkData?.target}
                onFocus={() => {
                  setHotSpotFocus((hotSpotFocusRef.current = id));
                }}
                onBlur={() => {
                  setHotSpotFocus(undefined);
                }}
                onClick={e => {
                  requestAnimationFrame(() => {
                    updateHotspotSeen(id);
                  });
                }}
              />
            ) : (
              <button
                key={`hotspot-focus-trigger-${index}`}
                id={`hotspot-focus-trigger-${id}`}
                css={css({
                  position: 'absolute',
                  outline: 'none',
                  border: 'none',
                  width: 0,
                  height: 0,
                  overflow: 'hidden',
                })}
                aria-label={`${name}${addHasBeenSeenTitleOrLabel}`}
                onFocus={() => {
                  setHotSpotFocus((hotSpotFocusRef.current = id));
                }}
                onBlur={() => {
                  setHotSpotFocus(undefined);
                }}
                onClick={e => {
                  if (!immediateFeedback) {
                    // we're quizzin' it
                    if (window.dev()) {
                      return;
                    } else {
                      updateSelected(index);
                      //
                      return;
                    }
                  }

                  setShowFeedback(id);

                  requestAnimationFrame(() => {
                    updateHotspotSeen(id);
                  });
                }}
              />
            );
          })}
        </div>
      </div>
      {showFeedback && (
        <Feedback
          useMediaInFeedback={useMediaInFeedback}
          onClose={() => {
            if (hotSpotFocusRef.current) {
              requestAnimationFrame(() => {
                const hotSpotFocusTrigger = document.querySelector(
                  `#hotspot-focus-trigger-${hotSpotFocusRef.current}`
                ) as HTMLButtonElement;
                if (hotSpotFocusTrigger) {
                  hotSpotFocusTrigger.focus();
                }
              });
            }
            //
            setShowFeedback(null);
          }}
        >
          {feedback}
        </Feedback>
      )}

      {SVGHasNoDimensionsError && (
        <img
          src={HotspotSVGError}
          css={css({
            position: 'relative',
            width: '100%',
            cursor: 'pointer',
            borderRadius: '45px',

            boxShadow: `0 0 0 1px transparent`,

            ...(isFocused && {
              pointerEvents: 'none',
              boxShadow: `0 0 0 1px ${lPink}`,
            }),

            ':hover': {
              boxShadow: `0 0 0 1px ${lPink}`,
            },
          })}
          onClick={() => {
            setCurrentBlock({ id });
          }}
        />
      )}

      {window.dev() && (!image || imgLoading === 2) && (
        <EditWrapper
          id={props.id}
          width={imgSize[0] * scale}
          height={imgSize[1] * scale}
        />
      )}
    </div>
  ) : null;
};

export default HotSpot;
